/* eslint-disable */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from "moment";
import "moment/locale/en-gb";
import Select from "react-select";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import Modal from "components/Modal";
import apiService from "services/apiService";
import CustomToolbar from "./CustomToolbar";
import AddTimeSheet from "./AddTimeSheet";
import EventInfo from "./EventInfo";
import Tooltip from "components/Tooltip";
const Localizer = momentLocalizer(moment);
const DragAndDropCalendar = withDragAndDrop(Calendar);
import { useTranslation } from "react-i18next";
import { useAppContext } from "contexts";
import { sortByKey } from "util/sortOptions";
import EditTimeSheet from "./EditTimeSheet";
import { storageService } from "services/storageService";
import GenericModal from "components/Modal";
import { useToaster } from "contexts/toasterContext";

const CustomDateHeader = ({ label, date }: any) => {
  const isCurrentDate = moment(date).isSame(moment(), 'day');

  return (
    <div className="flex justify-center mt-1">
      <span
        className={`
            inline-flex items-center justify-center w-7 h-7 rounded-full text-sm
            ${isCurrentDate
            ? "bg-blue-100 text-black font-bold dark:bg-blue-900 dark:text-white"
            : "text-gray-700 dark:text-gray-200"}
          `}
      >
        {label}
      </span>
    </div>
  );
};

const TimeSheetCalendar: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [events, setEvents] = useState<any>([]);
  const [selectedEvent, setSelectedEvent] = useState<any>(null);
  const [openModal, setOpenModal] = useState(false);
  const [eventDetailsModal, setEventDetailsModal] = useState(false);
  const [currentMonth, setCurrentMonth] = useState("");
  const [currentYear, setCurrentYear] = useState("");
  const [selectedProject, setSelectedProject] = useState<number | null>(null);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [projects, setProjects] = useState<any>([]);
  const [wholeData, setWholeData] = useState();
  const { t } = useTranslation();
  const { user, userRole } = useAppContext();
  const [refresh, setRefresh] = useState(0);
  const [selectedDate, setSelectedDate] = useState();
  const [isDelete, setIsDelete] = useState(false);
  const [selectId, setSelectId] = useState<number>(0);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [workLocations, setWorkLocations] = useState<Record<string, any>>({});
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const calendarDateRef = useRef<Date>(new Date());
  const [pendingAddDate, setPendingAddDate] = useState<Date | null>(null);
  const [loadedMonthKey, setLoadedMonthKey] = useState("");
  const viewedMonthKeyRef = useRef("");
  // Detect dark mode changes
  useEffect(() => {
    const checkDarkMode = () => {
      setIsDarkMode(document.documentElement.classList.contains('dark'));
    };

    checkDarkMode();

    // Watch for dark mode changes
    const observer = new MutationObserver(checkDarkMode);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });

    return () => observer.disconnect();
  }, []);

  const { addToast } = useToaster();
  const handleProjectChange = (selectedOption: any) => {
    setSelectedProject(selectedOption.value);
  };

  const handleUserChange = (selectedOption: any) => {
    console.log("Selected user:", selectedOption.value);
    setSelectedProject(null);
    setProjects(null);
    setSelectedUser(selectedOption.value.email);
    setProjects(selectedOption?.value?.userProjectWithAssignedDate);
  };

  const handleEventSelect = (event: any) => {
    if (event.isHoliday || event.isLeave) {
      return;
    }
    console.log("Selected event:", event);
    console.log("Event details:", {
      id: event.id,
      title: event.title,
      start: event.start,
      end: event.end,
      projectId: event.projectId,
      hour: event.hour,
      description: event.description,
      projectName: event.projectName
    });
    setSelectedEvent(event);
    setEventDetailsModal(true);
  };
  const projectOptions: { value: any; label: any }[] =
    projects && projects.length > 0
      ? projects.map((project: any) => ({
        value: project.projectId,
        label: project.name,
      }))
      : [];
  const TempUsers =
    users &&
    users.map((res: any) => ({
      value: res,
      label: res.displayName,
    }));
  const userOption = sortByKey(TempUsers, "label");
  const onSelectSlot = (e: any) => {
    // 1. Prevent slot selection if any modal is already open
    if (edit || openModal || eventDetailsModal) {
      console.log("Modal is open, ignoring slot selection");
      return;
    }

    // 2. Validate that e has required properties
    if (!e || !e.start || !e.end) {
      console.error("Invalid slot selection:", e);
      return;
    }

    // 3. REMOVED: Leave blocking logic 
    // This previously prevented opening the modal on leave days.
    // By removing this check, you allow the modal to open on any valid calendar slot.

    // 4. Validate the selected date
    const selectedMoment = moment(e.start);
    if (!selectedMoment.isValid()) {
      console.error("Invalid date selected:", e.start);
      return;
    }

    const currentDisplayMonthStart = moment(`${currentYear}-${currentMonth}`, "YYYY-MMM").startOf("month");
    const currentDisplayMonthEnd = moment(`${currentYear}-${currentMonth}`, "YYYY-MMM").endOf("month");

    if (selectedMoment.isBefore(currentDisplayMonthStart, "day")) {
      addToast("To fill a timesheet for a previous month's date, navigate to that month's calendar.", "error");
      return;
    }

    if (selectedMoment.isAfter(currentDisplayMonthEnd, "day")) {
      if (selectedMoment.isAfter(moment(), "day")) {
        addToast("Future date timesheet entry is not allowed.", "error");
      } else {
        openAddForOtherMonth(e.start);
      }
      return;
    }

    // 5. Open the modal
    if (selectedMoment.format("MMM") === currentMonth) {
      openAddPopup(e.start);
    }
  };

  const openAddPopup = (date: Date) => {
    setSelectedDate(date as any);
    setOpenModal(true);
  };
  const openAddForOtherMonth = (date: Date) => {
    calendarDateRef.current = date;
    setCurrentMonth(moment(date).format("MMM"));
    setCurrentYear(moment(date).format("YYYY"));
    setRefresh((prev) => prev + 1);
    setPendingAddDate(date);
  };

  useEffect(() => {
    if (!pendingAddDate) return;
    if (loadedMonthKey !== moment(pendingAddDate).format("YYYY-MMM")) return;
    openAddPopup(pendingAddDate);
    setPendingAddDate(null);
  }, [pendingAddDate, loadedMonthKey]);

  const handlePopupDragStart = useCallback(() => undefined, []);

  const dayPropGetter = useCallback(
    () => {
      return {};
    },
    [],
  );
  const handleNavigate = (date: Date) => {
    console.log("Current month:", moment(date).format("MMM"));
    console.log("Current year:", moment(date).format("YYYY"));
    calendarDateRef.current = date;
    setCurrentMonth(`${moment(date).format("MMM")}`);
    setCurrentYear(moment(date).format("YYYY"));
  };
  const handleView = () => {
    const currentDate = new Date();
    setCurrentMonth(`${moment(currentDate).format("MMM")}`);
    setCurrentYear(moment(currentDate).format("YYYY"));
  };

  useEffect(() => {
    handleView();
  }, []);
  const getTimeSheetData = (payload: any) => {
    const queryParams = new URLSearchParams({
      year: payload.year.toString(),
      month: payload.month,
      ...(payload.projectId && { projectId: payload.projectId.toString() }),
      ...(payload.email && { email: payload.email }),
    });
    const url = `api/timesheet?${queryParams.toString()}`;
    console.log("url => ", url);
    return apiService.get(url);
  };
  function removeDuplicates(arr: any) {
    const map = new Map();

    arr.forEach((entry: any) => {
      const key = `${entry.title}-${entry.projectId}-${entry.hour}-${entry.start}`;
      if (!map.has(key)) {
        map.set(key, entry);
      }
    });

    return Array.from(map.values());
  }
  useEffect(() => {
    const payload = {
      year: currentYear,
      month: currentMonth,
      email: selectedUser,
      projectId: selectedProject,
    };
    // console.log("payload", payload);
    if (payload.year) {
      const requestedMonthKey = `${currentYear}-${currentMonth}`;
      viewedMonthKeyRef.current = requestedMonthKey;
      apiService
        .get(`api/timesheet/${currentYear}/${currentMonth}`)
        .then((res) => {
          if (viewedMonthKeyRef.current !== requestedMonthKey) return;
          console.log("res.data", res.data);
          setWholeData(res.data);
          const timesheetdata: any[] = [];
          const AA = res.data;
          console.log("res.data.month :>> ", res.data.month);
          const monthString = res.data.month;
          const monthIndex = moment().month(monthString).month();
          if (AA) {
            const eventData = AA.data;
            console.log("eventData :>> ", eventData);
            eventData &&
              eventData.map((val: any, i: number) => {
                if (eventData) {
                  const details = eventData[i].detail;
                  const event = details
                    .filter((detail: any) => detail.task.trim() !== "")
                    .map((detail: any) => ({
                      id: detail.id,
                      title: detail.task,
                      projectId: eventData[i].projectId,
                      // Carry the group-level projectName onto each event so the
                      // selected event is self-contained (previously undefined —
                      // only projectId was copied, so selectedEvent.projectName
                      // and any log/UI reading it came back undefined).
                      projectName: eventData[i].projectName,
                      hour: detail.hour,
                      // start: new Date(detail.day),
                      // end: new Date(detail.day),
                      start: moment()
                        .set({
                          date: detail.day,
                          month: monthIndex,
                          year: parseInt(currentYear, 10),
                          // hour: 9,
                        })
                        .toDate(),
                      end: moment()
                        .set({
                          date: detail.day,
                          month: monthIndex,
                          year: parseInt(currentYear, 10),
                          // hour: 19,
                        })
                        .toDate(),
                      allDay: true,
                    }));
                  timesheetdata.push(...event);
                }
              });
            console.log("timesheetdata :>> ", timesheetdata);
            const uniqueArray = timesheetdata.filter(
              (item, index, self) =>
                index ===
                self.findIndex(
                  (t) =>
                    t.title === item.title &&
                    t.hour === item.hour &&
                    t.start === item.start,
                ),
            );
            console.log("uniqueArray :>> ", uniqueArray);
            const uniqueEntries = removeDuplicates(uniqueArray);
            setEvents(uniqueEntries);
          }
          setLoadedMonthKey(requestedMonthKey);
        })
        .catch((err) => {
          console.log("get timesheet error :>>", err);
          if (viewedMonthKeyRef.current === requestedMonthKey) {
            setPendingAddDate(null);
          }
        });
    }
  }, [currentYear, currentMonth, refresh]);

  /**
   * NOTE: leave / holiday events are styled through a class instead of an inline
   * backgroundColor. A continuous multi-day leave renders as one wide bar, and a
   * fully saturated fill made it read as a heavy slab across the week. The class
   * lets the stylesheet below give it a soft tinted ribbon (same red/green badge
   * tokens already used for the day-cell badges in this file), keep dark mode
   * working, and square off the edges where a leave continues into the next week.
   */
  const eventPropGetter = (event: any) => {
    if (event.isHoliday || event.isLeave) {
      return { className: event.isLeave ? "hr-event-leave" : "hr-event-holiday" };
    } else {
      return event;
    }
  };

  // 2. Fetch work location data month-wise based on calendar navigation
  useEffect(() => {
    if (!user?.id || !currentYear || !currentMonth) return;

    const selectedMonthMoment = moment(
      `${currentYear}-${currentMonth}`,
      "YYYY-MMM",
      true,
    ).startOf("month");

    if (!selectedMonthMoment.isValid()) return;

    const currentMonthMoment = moment().startOf("month");
    const fromDate = selectedMonthMoment.format("YYYY-MM-DD");
    const toDate = selectedMonthMoment.endOf("month").format("YYYY-MM-DD");

    // Rules:
    // - Current month load -> fromDate only
    // - Previous month navigation -> fromDate only
    // - Future month navigation -> fromDate + toDate
    const params =
      selectedMonthMoment.isAfter(currentMonthMoment)
        ? `?fromDate=${fromDate}&toDate=${toDate}`
        : `?fromDate=${fromDate}`;

    apiService
      .get(`api/work-location/summary/${user.id}${params}`)
      .then((res) => {
        const data = res.data.dailyBreakdown || {};
        setWorkLocations((prev) => ({ ...prev, ...data }));
        setRefresh((prev) => prev + 1);
      })
      .catch((err) => console.log("work location error", err));
  }, [user?.id, currentYear, currentMonth]);

  const CustomDateCellWrapper = ({ children, value }: any) => {
    const dateKey = moment(value).format("YYYY-MM-DD");
    const workData = workLocations[dateKey];
    const dayMoment = moment(value).startOf("day");

    const dayLeaveEvents = leaves.filter((event: any) => {
      if (!event?.isLeave || !event?.start || !event?.end) {
        return false;
      }

      const leaveStart = moment(event.start).startOf("day");
      const leaveEndExclusive = moment(event.end).startOf("day");
      return dayMoment.isSameOrAfter(leaveStart) && dayMoment.isBefore(leaveEndExclusive);
    });

    const hasWorkLocationBadges = Boolean(workData?.locationTypes?.length);
    const hasLeaveBadges = dayLeaveEvents.length > 0;

    return (
      <div className="h-full w-full flex flex-col relative rbc-day-bg">
        {hasWorkLocationBadges ? (
          <div className="flex flex-wrap gap-1 p-1 z-10">
            {workData?.locationTypes?.map((type: string) => {
              const hours = type === "WFO" ? workData.wfoHours : workData.wfhHours;
              const baseClass =
                type === "WFO"
                  ? "bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-200"
                  : "bg-yellow-100 text-yellow-700 dark:bg-yellow-900 dark:text-yellow-200";

              return (
                <span
                  key={`${dateKey}-${type}`}
                  className={`px-1.5 py-[1px] rounded text-[10px] font-bold ${baseClass} whitespace-nowrap`}
                >
                  {type}
                  {hours != null ? ` ${hours}h` : ""}
                </span>
              );
            })}

            {dayLeaveEvents.map((leaveEvent: any) => (
              <span
                key={`${dateKey}-leave-${leaveEvent.id || leaveEvent.title}`}
                className="px-1.5 py-[1px] rounded text-[10px] font-bold whitespace-nowrap bg-red-100 text-red-700 dark:bg-red-900 dark:text-red-200"
              >
                {leaveEvent.title || "Leave"}
              </span>
            ))}
          </div>
        ) : (
          <div className="h-5" /> // Maintain vertical alignment
        )}

        {/* Ensure the date number is always visible */}
        <div className="flex-grow">{children}</div>
      </div>
    );
  };

  const [holidays, setHolidays] = useState<any>([]);
  const [leaves, setLeaves] = useState<any>([]);

  const getLeaveRowsFromPayload = (payload: any) => {
    if (Array.isArray(payload)) {
      return payload;
    }

    if (Array.isArray(payload?.content)) {
      return payload.content;
    }

    return [];
  };

  useEffect(() => {
    if (!currentYear || !currentMonth) {
      return;
    }

    const email = selectedUser || user?.email;
    if (!email) {
      return;
    }

    const url = `/api/leave/data/${currentYear}?email=${email}`;

    apiService
      .get(url)
      .then((res) => {
        const leaveRows = getLeaveRowsFromPayload(res.data);
        const visibleLeaveRows = leaveRows.filter((leave: any) => {
          const rawStatus =
            leave?.status ?? leave?.leaveStatus ?? leave?.leave_status ?? "";
          const normalizedStatus = String(rawStatus).trim().toLowerCase();

          // Exclude only rejected leaves; keep all other statuses as-is.
          return normalizedStatus !== "rejected";
        });

        const calendarEvents = visibleLeaveRows.map((leave: any) => {
          const start = moment(leave.leaveFrom).startOf("day").toDate();
          const end = moment(leave.leaveTo).startOf("day").add(1, "day").toDate();

          return {
            id: leave.id,
            title: leave.leaveType || "Leave",
            start,
            end,
            allDay: true,
            isLeave: true,
          };
        });

        setLeaves(calendarEvents);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }, [currentYear, currentMonth, selectedUser, user?.email]);
  useEffect(() => {
    const currentDate = new Date();
    const year = moment(currentDate).format("YYYY");
    const url = `/api/holiday/${year}`;
    console.log("holiday url", url);
    apiService
      .get(url)
      .then((res) => {
        console.log("holidays", res.data);
        const holidayEvents = res.data.map((holiday: any) => ({
          id: holiday.holidayId,
          title: holiday.occasion,
          start: new Date(holiday.holidayDate).toISOString(),
          end: new Date(holiday.holidayDate).toISOString(),
          allDay: true,
          isHoliday: true,
        }));
        console.log("holidayEvents", holidayEvents);
        setHolidays(holidayEvents);
      })
      .catch((err) => {
        console.log("get holidays error", err);
      });
  }, []);
  const CustomEvent = ({ event }: any) => (
    <Tooltip content={event.title}> {event.title}</Tooltip>
  );

  useEffect(() => {
    if (user) {
      setSelectedUser(user.email);
      setProjects(user.userProjectWithAssignedDate);
    }
  }, [user]);
  const [taskId, setTaskId] = useState<any>(null);
  const [edit, setEdit] = useState(false);
  const handleEdit = (eventData: any) => {
    console.log("Editing task with event data:", eventData);
    if (!eventData) {
      console.warn("eventData is null or undefined");
      return;
    }

    // Validate that eventData has required properties
    if (!eventData.start || !eventData.projectId) {
      console.error(
        "Invalid event data - missing required properties:",
        eventData,
      );
      addToast("Invalid event data", "error");
      return;
    }

    console.log("Proceeding with edit for event:", eventData);
    setTaskId(eventData);
    setEventDetailsModal(false);
    setEdit(true);
  };

  const handleCloseEdit = () => {
    setEdit(false);
    setTaskId(null); // Clear taskId when closing
  };

  //  Implemented Delete functionality

  const handleDelete = (taskId: number) => {
    console.log("selected id >>: " + taskId);
    setIsDelete(true);
    setSelectId(taskId);
  };

  const deleteHandle = (id: number) => {
    apiService
      .delete(`api/timesheet/delete/${id}`)
      .then((res) => {
        console.log(res);
        addToast("Time Sheet deleted Sucessfully", "success");
        setRefresh(refresh + 1);
        setEventDetailsModal(false);
      })
      .catch((error) => {
        console.log("error " + error);
        addToast((error.message) || "Something went wrong ", "error");
      })
      .finally(() => {
        setIsDelete(false);
        setRefresh(refresh - 1);
      });
  };

  return (
    <>
      {/* <BreadCrumb BreadCrumbList={BreadCrumbList} /> */}
      <div className="bg-gray-50 dark:bg-gray-800 p-4">
        <Modal
          isOpen={edit}
          onClose={handleCloseEdit}
          header="Edit Timesheet"
          customWidth="max-w-2xl"
        >
          <EditTimeSheet
            projects={projects}
            selectedProj={selectedProject}
            selectedUser={selectedUser}
            month={currentMonth}
            year={currentYear}
            onClose={handleCloseEdit}
            wholeData={wholeData}
            setRefresh={setRefresh}
            refresh={refresh}
            selectedDate={selectedDate}
            taskId={taskId}
          />
        </Modal>
        <Modal
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          header="Add Timesheet"
          customWidth="800px"
        >
          <AddTimeSheet
            projects={projects}
            selectedProj={selectedProject}
            selectedUser={selectedUser}
            month={currentMonth}
            year={currentYear}
            onClose={() => setOpenModal(false)}
            wholeData={wholeData}
            setRefresh={setRefresh}
            refresh={refresh}
            selectedDate={selectedDate}
          />
        </Modal>
        {selectedEvent && eventDetailsModal && (
          <Modal
            isOpen={eventDetailsModal}
            onClose={() => setEventDetailsModal(false)}
            header="Timesheet Info"
          >
            <EventInfo
              selectedEvent={selectedEvent}
              projects={projects}
              handleEdit={handleEdit}
              handleDelete={handleDelete}
            />
          </Modal>
        )}
        {isDelete && (
          <GenericModal
            isOpen={isDelete}
            onClose={() => setIsDelete(false)}
            header="Delete Time sheet"
          >
            <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
              <div className="p-4 md:p-5 text-center">
                <svg
                  className="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                  />
                </svg>
                <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                  Are you sure you want to delete this Data?
                </h3>
                <button
                  data-modal-hide="popup-modal"
                  type="button"
                  className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center"
                  onClick={() => deleteHandle(selectId)}
                >
                  Yes, Im sure
                </button>
                <button
                  data-modal-hide="popup-modal"
                  type="button"
                  className="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                  onClick={() => setIsDelete(false)}
                >
                  No, cancel
                </button>
              </div>
            </div>
          </GenericModal>
        )}

        <div className="flex justify-end hidden ">
          {!userRole && (
            <>
              {users && (
                <div className="me-2 w-64 " style={{ zIndex: 9999 }}>
                  <Select
                    name="user"
                    options={userOption}
                    value={userOption.find(
                      (option) => option.value === selectedUser,
                    )}
                    onChange={handleUserChange}
                    placeholder={t("timesheet.selectuser")}
                    className="select"
                    defaultValue={userOption.find(
                      (option) => option.value.email === user.email,
                    )}
                  />
                </div>
              )}
            </>
          )}
          <div className="me-2 w-64 " style={{ zIndex: 99 }}>
            <Select
              name="project"
              options={projectOptions}
              value={projectOptions.find(
                (option) => option.value === selectedProject,
              )}
              onChange={handleProjectChange}
              placeholder={t("timesheet.selectproject")}
              className="select"
              isDisabled={true}
            // isDisabled={!selectedUser}
            // defaultValue={projects?.value?.userProjectWithAssignedDate}
            // isMulti
            />
          </div>
          <Tooltip content="Add Timesheet">
            {" "}
            <button
              type="button"
              onClick={() => setOpenModal(true)}
              className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
            >
              + {t("timesheet.addTimesheet")}
            </button>
          </Tooltip>
        </div>
        <div className="p-4 dark-calendar-wrapper">
          <style>
            {`
              .dark .dark-calendar-wrapper .rbc-calendar {
                background-color: #1f2937;
                color: #f9fafb;
              }
              .dark .dark-calendar-wrapper .rbc-header {
                background-color: #1f2937;
                color: #f9fafb;
                border-color: #4b5563;
              }
              .dark .dark-calendar-wrapper .rbc-month-view {
                background-color: #1f2937;
                border-color: #4b5563;
              }
              .dark .dark-calendar-wrapper .rbc-day-bg {
                background-color: #1f2937;
                border-color: #4b5563;
              }
              .dark .dark-calendar-wrapper .rbc-off-range-bg {
                background-color: #111827;
              }
              .dark .dark-calendar-wrapper .rbc-today {
                background-color: #1e40af !important;
              }
              .dark .dark-calendar-wrapper .rbc-date-cell {
                color: #f9fafb;
              }
              .dark .dark-calendar-wrapper .rbc-off-range {
                color: #6b7280;
              }
              .dark .dark-calendar-wrapper .rbc-month-row {
                border-color: #4b5563;
              }
              .dark .dark-calendar-wrapper .rbc-day-slot .rbc-time-slot {
                border-color: #4b5563;
              }
              .dark .dark-calendar-wrapper .rbc-time-content {
                border-color: #4b5563;
              }
              .dark .dark-calendar-wrapper .rbc-time-header {
                background-color: #1f2937;
                border-color: #4b5563;
              }
              .dark .dark-calendar-wrapper .rbc-time-header-content {
                border-color: #4b5563;
              }
              .dark .dark-calendar-wrapper .rbc-allday-cell {
                background-color: #374151;
              }
              .dark .dark-calendar-wrapper .rbc-time-content > * + * > * {
                border-color: #4b5563;
              }
              .dark .dark-calendar-wrapper .rbc-timeslot-group {
                border-color: #4b5563;
              }
              .dark .dark-calendar-wrapper .rbc-current-time-indicator {
                background-color: #ef4444;
              }
              .dark .dark-calendar-wrapper .rbc-agenda-view {
                background-color: #1f2937;
              }
              .dark .dark-calendar-wrapper .rbc-agenda-view table.rbc-agenda-table {
                border-color: #4b5563;
              }
              .dark .dark-calendar-wrapper .rbc-agenda-view table.rbc-agenda-table tbody > tr > td {
                border-color: #4b5563;
                color: #f9fafb;
              }
              .dark .dark-calendar-wrapper .rbc-agenda-view table.rbc-agenda-table thead > tr > th {
                background-color: #374151;
                border-color: #4b5563;
                color: #f9fafb;
              }
              .dark .dark-calendar-wrapper .rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {
                border-color: #4b5563;
              }
              .dark .dark-calendar-wrapper .rbc-agenda-date-cell,
              .dark .dark-calendar-wrapper .rbc-agenda-time-cell {
                color: #f9fafb;
              }
              .dark .dark-calendar-wrapper .rbc-show-more {
                background-color: #374151;
                color: #f9fafb;
              }

              /* ── Leave / Holiday ribbons ─────────────────────────────
                 A multi-day leave is one wide bar. Shaping it as a soft
                 tinted ribbon (instead of a solid saturated block) keeps
                 long ranges readable and matches the badge colours used
                 for WFH/WFO and leave inside the day cells. All rules are
                 scoped to .dark-calendar-wrapper so no other calendar or
                 page is affected. */
              .dark-calendar-wrapper .rbc-event.hr-event-leave,
              .dark-calendar-wrapper .rbc-event.hr-event-holiday {
                display: flex;
                align-items: center;
                gap: 6px;
                min-height: 20px;
                /* width:auto is required: RBC sets .rbc-event to width:100%, so
                   a horizontal margin on top of that shifted the ribbon right —
                   leaving a gap on its first day and overhanging the tile after
                   its last day. With auto width the margin insets both ends. */
                width: auto;
                margin: 1px 4px;
                padding: 2px 8px;
                border: 1px solid transparent;
                border-radius: 6px;
                font-size: 12px;
                font-weight: 600;
                line-height: 1.25;
                overflow: hidden;
                box-shadow: none;
              }

              /* RBC gives the label width:100%; beside the dot that would push
                 it out of the ribbon, so it becomes a shrinkable flex item */
              .dark-calendar-wrapper .rbc-event.hr-event-leave .rbc-event-content,
              .dark-calendar-wrapper .rbc-event.hr-event-holiday .rbc-event-content {
                flex: 1 1 auto;
                width: auto;
                min-width: 0;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }

              /* Leading dot, so the label reads as a tag rather than a fill */
              .dark-calendar-wrapper .rbc-event.hr-event-leave::before,
              .dark-calendar-wrapper .rbc-event.hr-event-holiday::before {
                content: "";
                flex: 0 0 auto;
                width: 6px;
                height: 6px;
                border-radius: 9999px;
                background-color: currentColor;
              }

              .dark-calendar-wrapper .rbc-event.hr-event-leave {
                background-color: #fee2e2;
                border-color: #fecaca;
                color: #b91c1c;
              }
              .dark .dark-calendar-wrapper .rbc-event.hr-event-leave {
                background-color: #7f1d1d;
                border-color: #b91c1c;
                color: #fecaca;
              }

              .dark-calendar-wrapper .rbc-event.hr-event-holiday {
                background-color: #dcfce7;
                border-color: #bbf7d0;
                color: #15803d;
              }
              .dark .dark-calendar-wrapper .rbc-event.hr-event-holiday {
                background-color: #14532d;
                border-color: #15803d;
                color: #bbf7d0;
              }

              /* A range that carries on into the next/previous week keeps a
                 flat, borderless edge so it reads as continuing */
              .dark-calendar-wrapper .rbc-event.hr-event-leave.rbc-event-continues-after,
              .dark-calendar-wrapper .rbc-event.hr-event-holiday.rbc-event-continues-after {
                margin-right: 0;
                border-right-color: transparent;
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
              }
              .dark-calendar-wrapper .rbc-event.hr-event-leave.rbc-event-continues-prior,
              .dark-calendar-wrapper .rbc-event.hr-event-holiday.rbc-event-continues-prior {
                margin-left: 0;
                border-left-color: transparent;
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
              }

              /* Agenda view gets the same class on its event cell */
              .dark-calendar-wrapper .rbc-agenda-event-cell.hr-event-leave {
                color: #b91c1c;
                font-weight: 600;
              }
              .dark .dark-calendar-wrapper .rbc-agenda-event-cell.hr-event-leave {
                color: #fecaca;
              }
              .dark-calendar-wrapper .rbc-agenda-event-cell.hr-event-holiday {
                color: #15803d;
                font-weight: 600;
              }
              .dark .dark-calendar-wrapper .rbc-agenda-event-cell.hr-event-holiday {
                color: #bbf7d0;
              }

              .rbc-overlay .rbc-event.hr-event-leave,
              .rbc-overlay .rbc-event.hr-event-holiday {
                display: none;
              }

              .rbc-overlay {
                width: 0;
              }
              .rbc-overlay .rbc-event-content {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            `}
          </style>
          <DragAndDropCalendar
            key={`calendar-${refresh}`}
            views={["month", "agenda", "week", "day", "work_week"]}
            selectable={!edit && !openModal && !eventDetailsModal}
            localizer={Localizer}
            events={[...events, ...holidays, ...leaves]}
            onSelectEvent={(event) => handleEventSelect(event)}
            style={{ height: 600 }}
            onSelectSlot={onSelectSlot}
            defaultDate={calendarDateRef.current}
            defaultView="month"
            resizable
            components={{
              toolbar: CustomToolbar,
              agenda: {
                event: CustomEvent,
              },
              month: {
                dateHeader: CustomDateHeader,
              },
              dateCellWrapper: CustomDateCellWrapper,
            }}
            popup
            handleDragStart={handlePopupDragStart}
            dayPropGetter={dayPropGetter}
            onNavigate={handleNavigate}
            onView={handleView}
            eventPropGetter={eventPropGetter}
          />
        </div>
      </div>
    </>
  );
};

export default TimeSheetCalendar;